const actionTypes = {
  InitializeOrder: 'INITIALIZE_ORDER',
};

export default actionTypes;
